import { MaskAsDefaultSmsTemplateMeta, MaskAsDefaultSmsTemplatePayload } from 'types/store/MaskAsDefaultSmsTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { maskAsDefaultSmsTemplateActions } from '../actions';

export default createAsyncReducer<MaskAsDefaultSmsTemplateMeta, MaskAsDefaultSmsTemplatePayload>(maskAsDefaultSmsTemplateActions);
